// Chinese (Simplified)
export const ZH_HANS = {
  banner: {
    error: "报价尚未更新，请稍候",
    copicate: "试试新的投资组合模式!",
    antimonitor: "点击此处前往购买和交易加密货币的最佳场所！",
  },
  footer: {
    donating: "如果您喜欢 CoinTrackr，请考虑进行捐赠！",
    right_reserve:
      "© 版权所有 " +
      new Date().getFullYear() +
      " CoinTrackr.com。保留部分权利。",
    version: "版本",
    changelog: "变更日志",
    powered_by: "技术支持",
  },
  top: {
    about: {
      info: "信息",
      FAQ: "常见问答",
      contact: "联系方式",
      partners: "合作伙伴",
      terms: "条款",
      privacy: "隐私",
    },
  },
  content: {
    valuation: {
      current_valuation: "当前估值",
      approx: "预计.",
    },
    profit_losses: "损益",

    updating_assets: "更新资产",
    updated_now: "上次更新：刚刚",
    last_update: `上次更新：{time} 秒前`,
    last_update_minutes: `上次更新：{minutes} 分 {seconds} 秒前`,
  },
  assets: {
    your_assets: "资产",
    add_asset: "添加资产",
    sort: "排序方式",
    sort_name: {
      name: "名称",
      exchId: "兑换",
      price: "价格",
      value: "估值",
      holdings: "持仓",
      percChangeHour: "小时",
      percChangeDay: "天",
      percChangeWeek: "周",
    },
  },
  charts: {
    color_help: "点击圆圈以更改颜色",
  },
  contact_page: {
    contact: "联系方式",
    help_feedback: "帮助和反馈",
    telegram: "Telegram",
    twitter: "Twitter",
    medium: "Medium",
    busines: "业务咨询",
    email: "邮件",
  },
  partner_page: {
    partners: "合作伙伴",
    bitsify: "Bitsify 将提供完整的 ICO 与众筹报告",
    bitcoin: "Bitcoin for Beginners 是适合初学者的加密货币学习社区。",
    interest: "想要成为我们的合作伙伴？",
    contact_us: "联系我们！",
  },
  user_menu: {
    not_logged: "未登录",
    icognito: "隐身",
    settings: "设置",
    sign_in: "登录",
    sign_out: "注销",
    valuation: "在标签页中展示估值",
    incognito: "隐身模式",
    night_mode: "夜间模式",
    share_link: "创建分享链接",
  },
  FAQ: {
    expand: "展开全部",
    collapse: "收起全部",
    0: {
      title: "CoinTrackr 是什么？",
      text:
        "CoinTrackr 一项免费、简单而又便于使用的服务，可助力追踪加密货币投资。",
    },
    1: {
      title: "我该如何在 CoinTrackr 上创建投资组合？",
      text:
        "这个问题的答案非常简单！只需移除示例投资组合中的资产，并以您自己的资产对其进行替换即可。您可通过点击某个资产来将其移除或对其进行编辑。",
    },
    2: {
      title: "CoinTrackr 会从哪里获取数字货币价格？这些价格是否准确？",
      text:
        '所有价格数据均取自 <a href="https://coinmarketcap.com">coinmarketcap.com</a>，以 CoinMarketCap 支持的所有交易所价格的平均值表示。鉴于 CoinTrackr 使用的是价格平均值，故其可能会与您所关注的交易所确切价格略有不同。',
    },
    3: {
      title: "如何从Cointrackr添加API密钥和交易？",
      text:
        '只需按照我们的专用页面<a href="/exchange/how-it-works">这里</a>中的说明操作即可。',
    },
    4: {
      title: "您是否计划添加更多的交易？",
      text:
        "是的，我们计划增加尽可能多的交易，他们提供为客户生成API密钥的可能性。",
    },
    5: {
      title: "估值是什么？如何确定其金额？",
      text:
        "估值是您添加至 CoinTrackr 中的资产的总价值；即您当前加密货币投资组合的总价值。",
    },
    6: {
      title: "为什么我找不到某些数字货币？",
      text:
        "如果您确定数字货币名称拼写正确，且又无法找到的话，那么应该是 CoinMarketCap 尚未对该数字货币做出支持。我们正在添加多个价格数据来源，您所感兴趣的数字货币将在未来得到支持。",
    },
    7: {
      title: "我的投资组合数据与登录信息会以何种方式存储？",
      text:
        "如果您未登录，那么所有数据都将存储于浏览器缓存中。您可关闭窗口并稍后继续，无需再次添加资产。" +
        "\n" +
        "如果您已在 CoinTrackr 上（使用社交媒体/邮件与密码）进行了注册，那么数据会被存储于数据库中。我们采用这一方式的目的是便于您在不同设备（如桌面端和移动端）之间进行实时同步，这样即使您清除了浏览器缓存，数据也会得到存储。",
    },
    8: {
      title: "创建 CoinTrackr 账户的过程是否安全？",
      text:
        '是。我们仅在实现 CoinTrackr 关键功能时使用您的数据。同时我们也不会将您的数据传递给第三方。请查看我们的<a href="/privacy">隐私政策<a/>了解详细信息。',
    },
    9: {
      title: "CoinTrackr 是否有兴趣与我的加密货币相关服务/社区开展合作？",
      text: '当然。请<a href="/contact">联系<a/>我们以探讨更多可能性！',
    },
  },
  add_page: {
    search: "按名称或标志进行搜索",
    add_asset: "添加资产",
    any_asset: {
      1: "支持所有已收录于",
      2: "的资产（数字货币与代币）",
    },
    next: "下一步",
    no_result: "未找到结果：",
  },
  register_page: {
    register: "注册",
    agree: "注册即表示您同意我们的",
    terms: "条件与条款",
    and: "以及",
    privacy: "隐私政策",
    p_reg:
      "只有当您想<b>保存投资组合</b>以在<b>其他设备</b>上使用，或者在<b>清除浏览器缓存</b>的情况下保护数据免遭丢失时才需要注册。",
    errors: {
      email_required: "邮件为必填项。",
      email_valid: "需提供有效的电子邮件",
      password_required: "密码为必填项。",
      password_length: "密码必须至少包含 {length} 个字符。",
      password_match: "密码必须匹配。",
    },
    placeholder: {
      email: "输入您的邮件",
      password: "输入您的密码",
      password_repeat: "重复您的密码",
    },
    create_account: "创建账户",
  },
  login_page: {
    placeholder: {
      email: "输入您的邮件",
      password: "输入您的密码",
    },
    errors: {
      email_not_found: "没有与此标识符对应的用户记录。用户可能已被删除。",
      not_email: "邮件地址格式不正确。",
    },
    forget_password_text: "如果您忘记密码，请单击此处重设密码",
    forget_password_text_back: "返回登录",
    reset_password: "重设密码",
    reset_password_p:
      "在下面输入您的电子邮件地址，我们将向您发送电子邮件以重置密码。",
    reset_password_success:
      "CoinTrackr 的密码重置消息已发送。 检查您的收件箱，然后回来。",
    // forget_password_text: '如果您忘记了密码，请发送邮件至 <a href="mailto:info@cointrackr.com">info@cointrackr.com</a> 进行重置',
  },
  share_page: {
    heading: "创建分享链接",
    just_second: "请稍候…",
    porfolio_not_found: "未找到投资组合",

    p_1:
      "<strong>CoinTrackr</strong> 是一款免费的<strong>加密货币投资组合管理工具</strong>，可帮助您追踪损益情况，并<strong>与他人分享您的投资组合</strong>。",
    create_own: "免费创建",

    p_2:
      "<strong>有人与您分享了其投资组合！</strong> <br> CoinTrackr 是一项免费的加密货币投资组合服务，支持超过 4,000 种数字货币与代币。",
    porfolio: "投资组合",
    profit_losed: "损益",

    created: "已创建",
    dialog: {
      p_1:
        "分享您的投资组合将创建一个<strong>公开链接</strong>，展示您的<strong>匿名投资组合</strong>。其中将<strong>仅包含百分比数据</strong>，不会展示估值或价格。此链接将无法用于追踪您的身份信息，可完全安全地与任何人共享。",
      add_message: "<strong>添加一则消息</strong> <em>（可选）</em>",
    },
    create_shareble: "创建分享链接",
    create_own_free: "创建您自己的投资组合",
    messages: {
      already: "您的投资组合链接已可分享！🙌",
      copied: "已复制您的链接！🎉",
      not_copied: "无法复制您的链接。请手动复制。😢",
      failed: "链接创建失败，请重试。😢",
    },
  },
  global: {
    add_first: "添加您的首个资产",

    not_now: "不是现在",
    not_right_now: "现在不要",
    close: "关闭",
    go_back: "返回",
    share: "%份额",

    price: "价格",

    day: "天",
    hour: "小时",
    week: "周",
    valuation: "估值",
    holdings: "持仓",
    name: "名称",
    actions: "操作",
    edit: "编辑",
    notes: "注释",

    last_7_days: "最近 7 天",
    last_24_hour: "最近 24 小时",
    last_hour: "最近 1 小时",

    login: "登录",
  },
  sign_in_dialog: {
    button: {
      email: "使用邮件登录",
      facebook: "使用 Facebook 登录",
      google: "使用 Google 登录",
      twitter: "使用 Twitter 登录",
    },
    p:
      "只有当您想<b>保存投资组合</b>以在<b>其他设备</b>上使用，或者在<b>清除浏览器缓存</b>的情况下保护数据免遭丢失时才需要登录账户。",
  },
  notifications: {
    sign_in: "您已登录。",
    sign_out: "您已注销。",
    HODL: "为什么不拿着呢？😭",
    dont_worry: "别担心，放轻松…然后把手攥紧了🎶🚀",
  },
  edit_asset_page: {
    add: "添加或编辑",
    how_much: "您持有多少 {assetName} {assetSymbol}？",
    save: "保存",
    delete: "删除",
    notes_label: "{assetName} {assetSymbol}的注释",
    notes_placeholder:
      "在此处添加您的注释，如购买价格、交易、钱包地址或与资产相关的任何其他注释",
  },
  exchange: {
    exchange: "兑换",
    trade: "贸易",

    your_api_keys: "您的API密钥",
    how_it_works: "它是如何工作的？",

    home_valuation_per_exchange: "每交易所估值",
    home_show_valuation_per_exchange: "显示每笔交易的估值",
    home_tooltip_info: "请参阅有关Exchange API密钥的信息",

    api_key: "API密钥",
    secret: "秘密",
    add: "添加",
    update: "更新",
    cancel: "取消",
    add_your_exchange_api_key: "添加你的{exchange}API密钥",
    add_exchange_api_key: "添加{exchange}API密钥",
    update_exchange_api_key: "更新{exchange}API密钥",
    api_keys_page_note:
      "重要提示：在存款/取款和任何已填写的订单之后，Binance会有15分钟的刷新延迟。<br/>报价是实时的",

    pick_a_ticker_to_trade: "选择要交易的股票：",
    select_ticker: "选择股票代码",

    loading: "加载..",
    Buy: "购买",
    Sell: "出售",
    LIMIT: "限制",
    MARKET: "市场",

    amount: "余额",
    you_have: "持有",
    total: "总额",

    place_buy_order: "下购买订单",
    place_sell_order: "下销售订单",

    order_placed: "订单已下！",

    you_dont_have_assets: "你没有可以交易的资产",

    orders_history: "订单历史",
    orders_open: "未结订单",
    orders_history_empty: "{ticker}的订单历史记录为空",
    orders_open_empty: "目前{ticker}没有公开订单",
    symbol: "符号",
    side: "一边",
    type: "类型",
    price: "价格",
    status: "职位",
    stopPrice: "止损价",
    executedQty: "执行数量",
    time: "时间",
    action: "行动",
  },
  exchange_info_page: {
    blocks: [
      {
        heading: "CoinTrackr主要更新",
        p: [
          "多年来，CoinTrackr为所有有价值的用户免费提供了数十亿份报价，现在，CoinTrackr自豪地宣布了一项重大突破，从今天开始，您可以在CoinTrackr上跟踪您在各种交易所持有的真正加密资产！还有一件事…。",
          "不仅仅是跟踪！Cointrackr也很高兴宣布这些资产的交易功能，这意味着您将能够在Cointrackr内跟踪和交易它们！！",
        ],
      },
      {
        heading: "它是如何工作的？",
        p: [
          "每个大型交易都允许用户使用API连接到另一个平台。例如，如下所示，Binance在此处提供此选项：",
          "1） 注册CoinTrackr，然后进入菜单“您的API密钥”",
          "2） 从Binance帐户复制粘贴API密钥和密钥。<br /> 下面是一幅描述步骤的快速图像：",
          "重要提示：仅激活“启用读取”和“启用现货和保证金交易”<br /> 和关于IP限制设置CoinTrackr IP地址：<strong>{exchangeApiIP}</strong>",
          "完成后，请等待15分钟以进行同步，转到主页，您将看到由Binance徽标表示的Binance中的资产。",
          "还有一个重要的区别是，在使用经典的CoinTrackr资产之前，您使用了编辑按钮，显然这个按钮变成了“交易”，因为从今天起，您可以在CoinTrackr上管理和交易您的交易所投资组合。",
          "现在让我们看看您的CoinTrack仪表板是什么样子：",
          "现在，在第一页，您将与Binance和经典CoinTrackr中的资产进行区分。",
          "正如您所看到的，您有一个新的列，用于区分每个交易所的资产。<br /> >Cointrackr徽标是为您一直跟踪的实际经典资产设置的。<br /> >Binance在这里，是您的真实资产在您的Binance live帐户跟踪。",
        ],
      },
      {
        heading: "交易平台",
        p: [
          "（在接受我们的条款和条件后）",
          "现在让我们看看CoinTrackr交易平台，您可以随时通过单击您的每项交易资产上的“交易”来访问该平台：",
          "如您在此处所见，单击“交易”后，您可以选择：<br /> “买入/卖出”，有两个选项“限价指令”和“市场”您的基础资产",
          '注意：为了启用此选项，当您使用“启用现货和保证金交易”选择创建Binance API时，应选择“授权交易”，<a href="#step-2-binance-setup">请单击此处再次查看Binance设置。</a>',
          "如果不想使用此功能，您仍然可以像以前一样跟踪资产。",
          "今天，我们提供跟踪的第一个交易是Binance，接下来是更多的交易：）",
          '<a href="mailto:info@cointrackr.com">info@cointrackr.com</a>如果您有任何问题或发现bug，谢谢。',
        ],
      },
    ],
  },
  profitloss: {
    pl: "利润率",
    profitloss: "利润/损失",
    realized_profitloss: "实现利润率",
    total_balance: "总余额",
    mode: "模式",
    portfolio: "文件夹",
    current: "当前",
    history: "历史",
    investment: "投资",
    average: "平均",
    transaction: "交易",
    transactions: "交易",
    hide: "隐藏",
    show: "显示",
    asset_notes_label: "资产注释标签",
    asset_notes_placeholder: "资产注释占位符",
    reset_portfolio: "重置投资组合",
    reset_portfolio_text: "重置文件夹文本",
    list_empty: "列表为空",

    quantity: "量",
    value: "价值",
    date: "日期",
    buy_price: "买价",
    buy_value: "购买价值",
    buy_date: "购买日期",
    showInValuation_help: "将损益计入当期估值",
    transaction_notes_placeholder: "添加与此交易相关的注释",
    sell_close: "成交",
    total_valuation: "总估值",
    delete_transaction_text: "删除交易记录",

    sell_price: "卖出价",
    sell_value: "卖价",
    sell_date: "出售日期",
    history_transaction_hint: "历史\交易\提示",

    original_buy_transaction: "原始购买交易",
    left_unsold: "未售出",
    originally: "初始",
    dependent_transactions: "您已关闭此资产的事务总计",
  },
};
